import { Component, OnInit } from '@angular/core';
import { ReponseCoordonneesCreditService } from '../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { FormulaireFiservService } from '../../services/formulaire-fiserv/formulaire-fiserv.service';
import { ActivatedRoute } from '@angular/router';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { ConfigMeta } from 'src/app/models/meta';
import { GestionProvenanceService } from '../../services/navigation/gestion-provenance.service';

@Component({
  selector: 'app-page-confirmation',
  templateUrl: './page-confirmation.component.html',
  standalone: false,
})
export class PageConfirmationComponent implements OnInit {
  titre: string = '';
  messageAlerte: string = '';
  extraAttribut: string = '';
  libelleHandle: string = '';
  isAppMobile: boolean;

  constructor(
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly cybermetrieService: CybermetrieCoordonneesService,
    private readonly formulaireFiservService: FormulaireFiservService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly gestionTitreService: GestionTitreService,
    private readonly gestionProvenanceService: GestionProvenanceService,
    private readonly gabaritService: GabaritService,
    private readonly configService: ConfigurationService
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe((data) => {
      this.libelleHandle = data.libelleHandle;
      this.titre = this.getTitre();
      this.messageAlerte = 'caad.page-confirmation.' + data.libelleHandle + '.message';
      this.gestionTitreService.addTitreOnglet(this.getTitreOnglet());
      this.isAppMobile = this.gabaritService.isAppMobile();
    });
    if (!this.isVueCoordonnees()) {
      this.extraAttribut = this.formulaireFiservService.getForm().controls.utiliserMemeAdresse.value
        ? CybermetrieEnum.OUI
        : CybermetrieEnum.NON;
      const extra = new Map<string, string>();
      extra.set(CybermetrieEnum.EXTRA_ATTRIBUT, this.extraAttribut);
      this.cybermetrieService.envoyerEvenementPersonnalise(
        CybermetrieEnum.CATEGORIE_TRANSACTION,
        CybermetrieEnum.ACTION_COMPLETE,
        CybermetrieEnum.LABEL_INFOS_TOTAL,
        null,
        null,
        extra
      );
    }
  }

  isVueCoordonnees(): boolean {
    return this.libelleHandle === 'coordonnees';
  }

  estBancaireActif(): boolean {
    return this.configService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true');
  }

  getUrlSecurite(): string {
    return this.configService.getValueOrBlank(ConfigMeta.OEL_URL_SECURITE);
  }

  estProvenanceExterne(): boolean {
    return this.gestionProvenanceService.estProvenanceExterne();
  }

  private getTitre(): string {
    if (this.isVueCoordonnees()) {
      return 'caad.page-confirmation.coordonnees.titre';
    }
    return this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()
      ? 'caad.titreMulticarte'
      : 'caad.titre';
  }

  private getTitreOnglet(): string {
    if (this.isVueCoordonnees()) {
      return 'caad.titreOnglet.page-confirmation.coordonnees';
    }
    if (this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()) {
      return 'caad.titreOnglet.page-confirmation.creditMulticarte';
    }
    return 'caad.titreOnglet.page-confirmation.credit';
  }
}
